import { render, staticRenderFns } from "./MapAreas.vue?vue&type=template&id=10b2711d&"
import script from "./MapAreas.vue?vue&type=script&lang=js&"
export * from "./MapAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports